export const ROUTE_DATA_CACHE_KEY = "routeDataCache";
export const OUTBOUND_FILTER_STATE_KEY = "outboundFilterState";



// WEBPACK FOOTER //
// ./src/components/outboundAmzl/util/LocalStorageKey.js